<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>location not assigned shipments - Delivery</strong>
          <!--   <div class="card-header-actions">
              <b-button type="button" variant="primary" @click="redirecttoDashborard" >Back</b-button>                     
            </div> -->
          </div> 
          <div class="table-responsive" >
            <table class="table table-striped table-bordered" border="1" >
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Shipping ID</th>
                  <th>Service Type</th>
                  <th>Order ID</th>
                  <th>Customer Name</th>
                  <th>Ship Location Id</th>
                  <th>Ship Address1</th>
                  <th>Ship Address2</th>
                  <th>Ship Mobile Number</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, firstIndex) in data">
                  <td>{{ firstIndex+1 }}</td>
                  <td>{{ value.shippingid }}</td>
                  <td>{{ value.servicetype }}</td>
                  <td>{{ value.orderid }}</td>
                  <td>{{ value.customername }}</td>
                  <td>{{ value.shippincode }}</td>
                  <td>{{ value.shipaddress1 }}</td>
                  <td>{{ value.shipaddress2 }}</td>
                  <td>{{ value.shipmobilenumber1 }}</td>
                </tr>
                 <tr v-if="this.data == 0">
                   <td colspan="10"> Record Not Found</td>
                </tr>  
              </tbody>
            </table>
          </div>
          <div class="modal" :class="{'is-active' : verificationCodeToggleInfo}">
            <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
              <div class="modal-background"></div>
              <div class="modal-card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Change Verification Code</p>
                  <button class="delete" type="button" @click="CloseVerificationCodeModal"></button>
                </header>
                <section class="modal-card-body">
                  <div class="field">
                    <p class="control">
                      <input class="input" type="text" name="Verification Code" v-model="customer.verificationcode" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-4.Verification Code') }"
                        placeholder="Change Verification Code">
                      <span v-show="errors.has('form-4.Verification Code')" class="help is-danger">{{ errors.first('form-4.Verification Code') }}</span>
                    </p>
                  </div>

                </section>
                <footer class="modal-card-foot" style="padding-left:542px">
                  <button class="button is-info" type="submit">Update</button>
                </footer>
              </div>
            </form>
          </div>
        </b-card>
      </b-col>
    </b-row>    
</div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      name: 'pickuplocation',
      data: [],
      clientdata: [],
      customerSearch: {},
      seen: true,
      verificationCodeToggleInfo: false,
      customer: {
        pickuplocationcountry: 'Dubai'
      },
      states: [
        'Abu Dhabi',
        'Al Ain',
        'Ajman',
        'Dubai',
        'Fujairah',
        'Ras Al Khaimah',
        'Sharjah',
        'Umm Al Quwain'
      ] 
    }
  },
  created: function() {
    this.displaydata()
    //this.displayclient()
  },
  methods: {
    validateForm(scope) {
      this.customer.pickuplonglat = this.longitude + ',' + this.latitude
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.createPickupLocation()
        }
      })
    },
    clear1: function() {},
    searchclear: function() {
      this.customerSearch = {}
      this.errors.clear('form-2')
    },
    chkmobileVal() {
      var chkValidate = true;
      var chknumb = /^[789]{1}\d{9}$/
      var mobilenumber = document.getElementById("mobilenumber").value
      if (mobilenumber.trim() === '0000000000' || mobilenumber.trim().length < 10) {
        chkValidate = false
        return false
      } else if (mobilenumber.trim() != "" && !(mobilenumber.trim().match(chknumb))) {
        chkValidate = false
        return false
      }
      return chkValidate = chkValidate;
    },
    createPickupLocation: function() {
      var chkmobileVal = this.chkmobileVal()
      if (chkmobileVal) {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.customer.lastmodifiedby = `${userInfo.sysemailid}`
        this.$validator.validateAll().then(result => {
          if (this.customer.pickuplocationtype === 'p2phub') {}
          if (result) {
            this.$http
              .post(
                `${CONSTANTS.API_URL}/PickUpLocationMasterAdd`,
                this.customer
              )
              .then(result => {
                alert('Added successfully')
                this.customer = {}
                this.longitude = ''
                this.latitude = ''
                this.customer.pickuplocationcountry = 'dubai'
                this.displaydata()
              })
              .catch(ex => {
                console.log('error', ex)
              })
            return
          } else {}
        })
      } else {
        alert('Please enter valid mobile number')
      }
    },
    getPickupLocationById: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      if (this.$route.params.id) {
        const obj = {
          lastmodifiedby: `${userInfo.sysemailid}`,
          pickuplocationmasterid: this.$route.params.id
        }
        this.$http
          .post(`${CONSTANTS.API_URL}/PickUpLocationMasterGet`, obj)
          .then(result => {
            this.customer = result.body[0]
          })
          .catch(ex => {
            console.log('error', ex)
          })
      }
    },
    validateForm2: function(scope) {
      this.displaydata(JSON.stringify(this.customerSearch))
    },
    displaydata: function(serchData) {
      const customerGetAllobj = serchData || {}
      this.$http
        .post(
          `${CONSTANTS.API_URL}/DelieveryNotAssignedShipmentsList`,
          customerGetAllobj
        )
        .then(result => {
          if (
            (result.body[0].returnmsg &&
              result.body[0].returnmsg === 'UnSuccessful') ||
            result.body[0].returnmsg === 'No Records Founnd'
          ) {
            alert('Result not found')
          } else {
            this.data = result.body
          }
        })
        .catch(ex => {
          console.log('error', ex)
        })
    },
    edituser: function(value) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.errors.clear('form-1')
      this.seen = true
      this.customer = JSON.parse(JSON.stringify(value))
      var latLogArray = value.pickuplonglat.split(',')
      this.longitude = latLogArray[0] || 0
      this.latitude = latLogArray[1] || 0
    },
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')
      this.longitude = ''
      this.latitude = ''
      this.customer.pickuplocationcountry = 'dubai'
    },
    displayclient: function() {
      this.$http
        .post(`${CONSTANTS.API_URL}/clientmastergetall`)
        .then(result => {
          this.clientdata = result.body
        })
        .catch(ex => {
          alert(ex)
        })
    },
    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.changeVerificationCode()
        }
      })
    },
    changeVerificationCode: function() {
        var result = []
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        // var passwObj = {
        //   deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
        //   deliveryagentpassword: `${this.customer.deliveryagentpassword}`,
        //   lastmodifiedby: `${userInfo.sysemailid}`
        // }
        // if (typeof this.customer.deliveryagentmasterid !== 'undefined') {
        //   this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster/ChangePassword`, passwObj)
        //     .then((result) => {
        //       Utils.notify('Password updated successfully', 'success')
        //       this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo
        //       this.customer = {}
        //       this.displaydata()
        //     })
        //     .catch((ex) => {
        //       console.log('error', ex)
        //     })
        // }
    },
    changeVerificationCodeModal: function(value) {
      this.customer.verificationcode = value.verificationcode
      this.verificationCodeToggleInfo = !this.verificationCodeToggleInfo
    },
    CloseVerificationCodeModal: function() {
      this.customer = {}
      this.verificationCodeToggleInfo = !this.verificationCodeToggleInfo
    },
    redirecttoDashborard: function() {
     window.location.href = `${CONSTANTS.BASE_URL}/#/dashboard`;
    }
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
}
</script>

